// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__TzGwy","logo":"Navbar_logo__PIoZR","schoolHeader":"Navbar_schoolHeader__vzqhL"};